import { useState, useEffect, useCallback } from 'react';
import { Button } from '../ui/button';
import { Wrench, Plus, MessageSquare } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import api from '../../lib/api';
import { MaintenanceFormDialog } from './MaintenanceFormDialog';
import { MaintStatusBadge, fmtDay, chatLink } from './maintenanceShared';

export const LesseeLeaseMaintenance = ({ vehicleId, el }) => {
    const [items, setItems] = useState(null);
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();

    const load = useCallback(() => {
        api.get(`/leasing/my-maintenance?vehicle_id=${vehicleId}`).then((r) => setItems(r.data)).catch(() => setItems(null));
    }, [vehicleId]);

    useEffect(() => { load(); }, [load]);

    if (items === null) return null;

    return (
        <div className="fleet-card p-5 space-y-3" data-testid="lessee-lease-maintenance">
            <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                    <Wrench className="w-5 h-5 text-amber-600" />
                    <h2 className="text-base md:text-lg font-semibold text-slate-800">{el ? 'Συντηρήσεις Leasing' : 'Leasing maintenance'}</h2>
                </div>
                <Button size="sm" onClick={() => setOpen(true)} className="bg-amber-500 hover:bg-amber-600 text-white rounded-sm" data-testid="lessee-maint-request-btn">
                    <Plus className="w-4 h-4 mr-1" />{el ? 'Αίτημα συντήρησης' : 'Request maintenance'}
                </Button>
            </div>
            {items.length ? items.map((m) => (
                <div key={m.id} className="flex flex-wrap items-center gap-3 p-3 border border-slate-100 rounded-sm" data-testid={`lessee-maint-${m.id}`}>
                    <div className="flex-1 min-w-[180px]">
                        <p className="font-medium text-slate-800">{m.service_type}</p>
                        {m.description && <p className="text-xs text-slate-500">{m.description}</p>}
                        {m.rejection_reason && <p className="text-xs text-red-600">{el ? 'Λόγος' : 'Reason'}: {m.rejection_reason}</p>}
                        {m.notes && <p className="text-xs text-slate-500">{el ? 'Σημειώσεις' : 'Notes'}: {m.notes}</p>}
                        {m.workshop && (
                            <p className="text-xs text-[#1B7EB5] mt-1" data-testid={`lessee-maint-workshop-${m.id}`}>
                                {el ? 'Συνεργείο' : 'Workshop'}: {m.workshop.name}{m.workshop.address ? `, ${m.workshop.address}` : ''}{m.workshop.city ? `, ${m.workshop.city}` : ''}{m.workshop.phone ? ` · ${m.workshop.phone}` : ''}
                            </p>
                        )}
                    </div>
                    <span className="text-xs text-slate-500">{['completed', 'awaiting_approval'].includes(m.status) ? fmtDay(m.completed_date, el) : fmtDay(m.scheduled_date, el)}</span>
                    <MaintStatusBadge status={m.status} el={el} testId={`lessee-maint-status-${m.id}`} />
                    <Button size="sm" variant="outline" onClick={() => navigate(chatLink(m))} data-testid={`lessee-maint-chat-${m.id}`}><MessageSquare className="w-4 h-4 mr-1" />{el ? 'Chat με υπεύθυνο' : 'Chat with manager'}</Button>
                </div>
            )) : <p className="text-sm text-slate-400" data-testid="lessee-maint-empty">{el ? 'Δεν υπάρχουν συντηρήσεις' : 'No maintenance yet'}</p>}
            <MaintenanceFormDialog
                open={open} onOpenChange={setOpen} el={el} vehicles={[]}
                title={el ? 'Αίτημα συντήρησης προς Leasing' : 'Maintenance request to leasing'}
                fields={['service_type', 'description']} submitLabel={el ? 'Αποστολή αιτήματος' : 'Send request'}
                endpoint="/leasing/my-maintenance" buildBody={(f) => ({ vehicle_id: vehicleId, service_type: f.service_type || '', description: f.description || '' })}
                onDone={load}
            />
        </div>
    );
};
